export const BP_TC_ITALY_ADDITION = `<p>Si prega inoltre di apporre il “flag” alla seguente casella in segno di conferma ed accettazione specifica ed integrale, ex artt. 1341 e 1342 cc, delle seguenti disposizioni:</p>
    <p>Termini e condizioni HP Business Partner:</p>
    <ul>
        <li>Art. 3 - Criteri di idoneità</li>
        <li>Art. 5 - Obblighi del Business Partner</li>
        <li>Art. 6 - Modifica, recesso e risoluzione</li>
        <li>Art. 7 - Sospensione e risoluzione</li>
        <li>Art. 8 - Audit da parte di HP o da terzi incaricati</li>
        <li>Art. 9 - Legge applicabile e giurisdizione</li>
        <li>Art. 10 - Privacy</li>
    </ul>`
